const MultimediaScreen = () => {
  
    return (
       <p>Multimedia Screen here</p>
    )
}

export default MultimediaScreen